import React, { useEffect } from 'react';
import { useStoreState } from 'easy-peasy';
import styled from 'styled-components';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { isUndefined } from 'lodash';
import { SubHeading } from './elements';
import client from '../utils/apolloClient';

const Container = styled.div``;

const placesQuery = gql`
  query searchPlaces($input: SearchInput) {
    search_places(input: $input) {
      place_listing {
        place_id
        display_order
        name
        address_line_1
        address_line_2
        city
        state
        country
        post_code
        status
        claim_status
      }
    }
  }
`;

const MenuPageHeader = ({
  title,
  place,
  placeId,
  placeData,
  setPlaceData,
  platform,
}) => {
  // const [placeData, setPlaceData] = useState(place);
  const { userId } = useStoreState(state => state.auth);

  useEffect(() => {
    if (!place) {
      client.clientPrivate
        .query({
          query: placesQuery,
          variables: {
            input: {
              user_id: userId,
              filter: { place_filter: { place_id: placeId } },
            },
          },
        })
        .then(({ data }) => {
          if (
            data &&
            data.search_places &&
            data.search_places.place_listing &&
            data.search_places.place_listing.length !== 0
          ) {
            setPlaceData(data.search_places.place_listing[0]);
          }
        });
    }
  }, []);

  return (
    <React.Fragment>
      {title && <SubHeading className="is-size-2">{title}</SubHeading>}
      <SubHeading className="is-size-2">
        {placeData && placeData.name}{' '}
        {placeData && platform === 'DELIVERECT' && (
          <a className="button  is-outlined">Deliverect</a>
        )}
      </SubHeading>
      {!isUndefined(placeData) && (
        <Container>
          <SubHeading className="is-size-2">
            {`${placeData && placeData.city}| ${placeData &&
              placeData.state}, ${placeData &&
              placeData.post_code} (${placeData && placeData.status})`}
          </SubHeading>
        </Container>
      )}
    </React.Fragment>
  );
};

MenuPageHeader.propTypes = {
  placeId: PropTypes.string.isRequired,
};

export default MenuPageHeader;
